/* src/app/shared/card/card-wrapper/card.component.scss */
:host {
  display: block;
  position: relative;
  background: #272626;
  padding: 12px 18px;
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 8px;
  overflow: hidden;
  transition: border-color 0.2s ease;
}
:host:not(.is-static):hover {
  border-color: rgba(255, 255, 255, 0.12);
}
:host.is-highlighted {
  border-color: rgba(255, 255, 255, 0.12);
}
/*# sourceMappingURL=card.component-T7EG7IBU.css.map */
